import axios from 'axios';
import EnvironmentUtils from '../utils/environment-utils';
import {
  applyAccessTokenInterceptor,
  applyPendingRequestCountInterceptor, applyTokenExpirationInterceptor,
} from './axios-interceptors';

const EnrouteApiClient = axios.create({
  baseURL: EnvironmentUtils.getVar('API_ENROUTE'),
});

applyAccessTokenInterceptor(EnrouteApiClient);
applyPendingRequestCountInterceptor(EnrouteApiClient);
applyTokenExpirationInterceptor(EnrouteApiClient)

export default EnrouteApiClient;
